import ColumnTemplate from '@vindr/ui/src/components/Templates/columns/columnRenderTemplates';
import { formatTimeColumn } from '@vindr/utils/dateTime';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { MENU_TYPE, QMS_ITEM_STATUS } from './qms.constant';
import { useGlobalState } from '../../../contexts/GlobalContext';
import { PERMISSIONS } from '@vindr/services/constants/permissions.constant';
import Tooltip from '@vindr/ui/src/components/ui/Tooltip';
import { PlayCircleOutlined } from '@ant-design/icons';
import { CallMissedOutlined, CheckOutlined } from '@vindr/icons';

const QMS_STATUS = {
  WAITING: 'QMS.Waiting',
  IN_PROGRESS: 'QMS.In Progress',
  DONE: 'QMS.Done',
  MISS_CALL: 'QMS.Miss Call',
}

const useDefinedColumnsOverview = ({ isPopup, handleContextMenuSelect, config }:
  { isPopup?: boolean; handleContextMenuSelect: (type: MENU_TYPE, record: any) => void; config: any }) => {
  const { t } = useTranslation('Vindoc');
  const { keycloak } = useGlobalState();

  return [
    // ColumnTemplate.Index({ pagination }),
    ...((isPopup && config?.wait_list_popup_patient_name !== 3)
    || (!isPopup && config?.wait_list_window_patient_name !== 3)) ? [{
      title: t('Patient Name'),
      width: 200,
      dataIndex: 'patient_name',
      key: 'patient_name',
      ellipsis: true,
      className: 'text-2xl',
    }] : [],
    ...((isPopup && config?.wait_list_popup_patient_id !== 3)
    || (!isPopup && config?.wait_list_window_patient_id !== 3)) ? [{
      title: t('Patient ID'),
      width: 100,
      dataIndex: 'patient_id',
      key: 'patient_id',
      ellipsis: true,
      className: 'text-2xl',
      render: (text, record) => {
        if (isPopup) {
          if (config?.wait_list_popup_patient_id === 2) return record.patient_id.slice(-4);
          return record.patient_id;
        } else {
          if (config?.wait_list_window_patient_id === 2) return record.patient_id.slice(-4);
          return record.patient_id;
        }
      },
    }] : [],

    ...((isPopup && config?.wait_list_popup_receive_at !== 3)
    || (!isPopup && config?.wait_list_window_receive_at !== 3)) ? [{
      title: t('Arrived Time'),
      width: 50,
      dataIndex: 'admission_time',
      key: 'admission_time',
      ellipsis: true,
      render: (text, record) => formatTimeColumn(record.admission_time),
      className: 'text-2xl',
    }] : [],

    ...((isPopup && config?.wait_list_popup_wait_time !== 3)
    || (!isPopup && config?.wait_list_window_wait_time !== 3)) ? [
      ColumnTemplate.WaitingTimeWithPriority({
        dataIndex: 'admission_time',
        width: 50,
        endIndex: 'none',
        resultIndex: 'none',
        sorter: true,
        title: t('Wait Time'),

        detailed: true,
        unit: 'minute',
        requirement: 'optional',
        interval: true,
        className: 'text-2xl',

        priorityIndex: 'priority',
        priorityBadges: {
          0: { show: false },
          1: { show: false },
          2: { show: false },
          3: { show: true, color: '#E59400', text: 'C' },
          4: { show: true, color: '#b23b00', text: 'KC' },
        },

        format: (val) => {
          const value = Number(val);

          if (value < 1) {
            return `< 1${t('Time.m')}`;
          } else if (value === 1) {
            return `1${t('Time.m')}`;
          } else if (value > 1) {
            return `${value}${t('Time.m')}`;
          }
        },
      }),
    ] : [],

    {
      title: t('Status'),
      dataIndex: 'qms_status',
      key: 'qms_status',
      width: 100,
      ellipsis: true,
      className: 'text-2xl',
      render: (text: number, row: any) => t(QMS_STATUS[QMS_ITEM_STATUS[row.qms_status]]),
    },

    ...(isPopup && keycloak.hasOneOfPerm([PERMISSIONS.qms.update])) ? [{
      title: '',
      valueType: 'option',
      dataIndex: 'id',
      width: 40,
      render: (text, row) => {
        return <div className="flex gap-2 text-2xl justify-center">
          {(row.qms_status === QMS_ITEM_STATUS.WAITING || row.qms_status === QMS_ITEM_STATUS.MISS_CALL) && <Tooltip title={t('QMS.Start')}>
            <Button type="text" onClick={() => handleContextMenuSelect(MENU_TYPE.IN_PROGRESS, row)}>
              <PlayCircleOutlined className="text-2xl text-blue-500" />
            </Button>
          </Tooltip>}
          {(row.qms_status === QMS_ITEM_STATUS.IN_PROGRESS) && (
            <>
              <Tooltip title={t('QMS.Done')}>
                <Button className="p-1 flex items-center" type="text" onClick={() => handleContextMenuSelect(MENU_TYPE.DONE, row)}>
                  <CheckOutlined className="text-lg text-green-500" />
                </Button>
              </Tooltip>
              <Tooltip title={t('QMS.Miss Call')}>
                <Button className="p-1 flex items-center" type="text" onClick={() => handleContextMenuSelect(MENU_TYPE.MISS_CALL, row)}>
                  <CallMissedOutlined className="text-2xl text-red-500" />
                </Button>
              </Tooltip>
            </>
          )}
        </div>
      }
    }] : [],
  ];
};

export default useDefinedColumnsOverview;
